module.exports = "img/flags/GL.0581b2c.png";